import { CloudOff, LockKeyhole, UserRound } from 'lucide-react'
import { useState, type FormEvent } from 'react'
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import { useOnlineStatus } from '../auth/useOnlineStatus'
import { Button } from '../components/ui'
import { errorMessage } from '../utils/format'

export function LoginPage() {
  const { user, login } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [identifier, setIdentifier] = useState('')
  const [password, setPassword] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState('')
  const online = useOnlineStatus()
  const message = (location.state as { message?: string } | null)?.message

  if (user) return <Navigate to="/" replace />

  async function submit(event: FormEvent) {
    event.preventDefault()
    setSubmitting(true)
    setError('')
    try {
      await login(identifier.trim(), password)
      const target = (location.state as { from?: string } | null)?.from || '/'
      navigate(target, { replace: true })
    } catch (caught) {
      setError(errorMessage(caught))
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <main className="login-page">
      <section className="login-intro">
        <div className="brand brand--light"><span className="brand__mark"><img src="/brand/logo.png" alt="" width="36" height="36" /></span><span><strong>Управление ТОиР</strong><small>ООО «БТТ-ГРУПП»</small></span></div>
        <div className="login-intro__content">
          <p className="eyebrow eyebrow--light">Управление ТОиР</p>
          <h1>Работы по объекту — от ППР до отчёта</h1>
          <p>Планируйте обслуживание, назначайте исполнителей, фиксируйте результат и контролируйте дефекты в одной рабочей среде.</p>
        </div>
        <div className="login-offline-note"><CloudOff size={20} /><span>После первого входа открытые данные и несохранённые действия останутся доступны на этом устройстве без подключения.</span></div>
      </section>
      <section className="login-panel">
        <form className="login-form" onSubmit={(event) => void submit(event)}>
          <div><p className="eyebrow">Защищённый доступ</p><h2>Вход в систему</h2><p>Логин и пароль выдаёт менеджер или администратор.</p></div>
          {!online && <div className="form-message form-message--warning" role="alert"><CloudOff size={18} /><span>Подключитесь к сети, чтобы войти.</span></div>}
          {message && <div className="form-message form-message--success" role="status">{message}</div>}
          {error && <div className="form-message form-message--error" role="alert">{error}</div>}
          <label className="field"><span>Логин или рабочая почта</span><div className="field__control"><UserRound size={18} /><input name="login" type="text" autoComplete="username" autoCapitalize="none" spellCheck={false} value={identifier} onChange={(event) => setIdentifier(event.target.value)} required placeholder="ivanov или name@company.ru" /></div></label>
          <label className="field"><span>Пароль</span><div className="field__control"><LockKeyhole size={18} /><input name="password" type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required placeholder="Введите пароль" /></div></label>
          <Button type="submit" loading={submitting} disabled={!online || !identifier.trim() || !password}>Войти</Button>
          <div className="login-links"><Link to="/recover-access">Не помню пароль</Link><Link to="/register">Запросить доступ</Link></div>
        </form>
      </section>
    </main>
  )
}
